var GS_DEALER = "42000055"; //NOTE: Replace with value from GreenSky
var GS_BASE_PLAN = "5944"; //NOTE: Replace with value from GreenSky
var GS_PROGRAM = "GreenSky eCommerce"; //DO NOT CHANGE
var GS_PROMO = ""; //OPTIONAL: Enter value from GreenSky, if provided
var GS_API_KEY = "QW1lcmljYW5Ib21lRml0bmVzczo3aGU3bjVleTlMVDN6ejhQ"; var GS_EXPERIENCE = 0; //DO NOT CHANGE
(function() {
	var s = document.createElement("script");
	s.src = "https://www.greensky.com/ecommerce/aslowas/gs-api-min.js";
	s.async = true;
	document.head.appendChild(s);
})();